import React, { Component } from 'react';

import { connect } from 'react-redux';

import { api, apiConst } from '../backend/api';

class Search extends Component {
  constructor(props) {
    super(props);
    this.state = {
      search: ''
    }
  }

  handleChangeText = (event) => {
    let tx = event.target.value;
    if(tx === ':connexion' || tx === ':Connexion') {
      //document.getElementById('search-input').blur();
      this.setState({ search: '' });
      this.props.showConnection();
    } else {
      this.setState({ search: tx });

      //this.props.searchMethod(tx);

    }
  };

  handleSubmit = (e) => {
    /* Prevent pressing enter from exiting the app */
    e.preventDefault();
    this.props.searchMethod(this.state.search)
  }

  onFocus = (e) => {
    e.target.addEventListener()
  }

  isAMailAddress(str) {
    if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(str)) {
      return true;
    }
    return false;
  }

  render() {
    console.log("admin", this.props.isAdmin)
    return(
      <div id='search'>
        <form id='search-form' onSubmit={this.handleSubmit} style={{ display: 'flex', justifyContent: 'flex', alignItems: 'center'}}>
          <input  id='search-input' className='classic-input shadow' type='text' name='name' placeholder='Consulter'
            value={this.state.search}
            onChange={this.handleChangeText} />
        </form>
        {
          this.props.isAdmin && this.isAMailAddress(this.state.search)
          ? <button
              style={{ marginLeft: 10, borderWidth: 0}}
              onClick={(e) => {
                api(apiConst.MAIL, {mail: this.state.search}, () => {
                  this.setState({search: ''});
                })
              }}
              className='regular-button shadow'>
                Inviter
            </button>
          : null
        }
      </div>
    );
  }
}

const mapStateToProps = state => {
  const { isAdmin } = state.userReducer;
  return { isAdmin };
}

export default connect(mapStateToProps, {})(Search);